import { render } from "./verify-sso.vue?vue&type=template&id=f47eb5d6"
import script from "./verify-sso.vue?vue&type=script&lang=js"
export * from "./verify-sso.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__